import api from './api';

/**
 * Design Project Import API Service
 * Provides methods for importing design projects from CSV
 */

// Upload and validate CSV file
export const uploadAndValidate = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/design-project-import/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// Confirm and execute import
export const confirmImport = (sessionId) =>
  api.post('/design-project-import/confirm', { sessionId });

// Download CSV template
export const downloadTemplate = () =>
  api.get('/design-project-import/template', { responseType: 'blob' });

// List import sessions
export const listSessions = (params = {}) =>
  api.get('/design-project-import/sessions', { params });

// Get session details
export const getSession = (sessionId) =>
  api.get(`/design-project-import/sessions/${sessionId}`);

// Rollback import session
export const rollbackSession = (sessionId) =>
  api.delete(`/design-project-import/sessions/${sessionId}/rollback`);

// Get unmapped names for mapping
export const getUnmappedNames = () =>
  api.get('/design-project-import/unmapped-names');

// Get users for mapping dropdown (filtered by roles)
export const getUsersForMapping = (roles) =>
  api.get('/design-project-import/users-for-mapping', { params: { roles } });

// Apply name to user mapping
export const applyNameMapping = (mappings) =>
  api.post('/design-project-import/apply-mapping', { mappings });

export default {
  uploadAndValidate,
  confirmImport,
  downloadTemplate,
  listSessions,
  getSession,
  rollbackSession,
  getUnmappedNames,
  getUsersForMapping,
  applyNameMapping
};
